import React from "react";
import { IconProps } from "../iconslib";

function Access({className} : IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} >
      <title>Close icon</title>
      <g clipPath="url(#clip0_203_3431)">
        <path d="M6.66656 18.6663L18.6669 6.66602L17.3333 5.33241L5.33296 17.3327L6.66656 18.6663Z" fill="var(--svg-base)"/>
        <path d="M18.6669 17.3343L6.66663 5.33398L5.33302 6.66759L17.3333 18.6679L18.6669 17.3343Z" fill="var(--svg-base)"/>
      </g>
      <defs>
        <clipPath id="clip0_203_3431">
        <rect width="24" height="24" fill="var(--svg-contrast)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Access;
